import imageVertexSource from './glsl/image.vertex';
import textureFragmentSource from './glsl/texture.frag';

import ImageFactory from'./ImageFactory';

import Matrix from '../geom/Matrix';

export default class QuadrantImage {

	static _inst = 0;

	_gl = null;
	_image = null;

	/* Texture cöordinate buffer */
	_tcb = null;

	/* Attribute buffers */
	_quadrant = null;
	_texcoords = null;

	_loading = null;

	constructor(gl, gor, name) {
		this._inst = QuadrantImage._inst++;
		this._gl = gl;
		this._gor = gor;
		try {
			this._shader = gor.createShaderProgram(`${name}_shader${this._inst}`, imageVertexSource, textureFragmentSource);
			this._vertices = gor.createVertexBuffer(`${name}_v${this._inst}`, 'vertex', 2, false);
			this._texcoords = gor.createVertexBuffer(`${name}_t${this._inst}`, 'tex', 2, false);
			this._vertices.update(new Float32Array([0,0, 1,0, 0,1, 1,1]));
			this._texcoords.update(new Float32Array([0,0, 0.5,0, 0,0.5, 0.5,0.5]));
			this._loading = new ImageFactory(this._gl, this._gor).create(`img/${name}.png`);
		} catch (e) {
			console.error(e);
			throw new Error(`Failed to initialise ${this.constructor.name}`);
		}
	}

	async load() {
		this._image = await this._loading;
	}

	defaultOpts() {
		return {
			/* overlay / underlay / always */
			mode: 'overlay',
			position: [0.0, 0.0],
			scale: 1,
			/* [x,y] for each quadrant, 0 is centre and 1 is corner */
			split: [[0,0], [0,0], [0,0], [0,0]],
			/* [quadrant-centered rotation, canvas-centered rotation] */
			rotation: [0, 0],
			/* Lol */
			hyper: [0, 0],
		};
	}

	draw(opts) {
		const gl = this._gl;
		const image = this._image;
		const shader = this._shader;
		const aspect = gl.drawingBufferHeight / gl.drawingBufferWidth;
		switch (opts.mode) {
		case 'overlay':
			gl.enable(gl.BLEND);
			gl.blendEquation(gl.FUNC_ADD);
			gl.blendFunc(gl.ONE_MINUS_DST_ALPHA, gl.ONE);
			break;
		case 'underlay':
			gl.blendFunc(gl.DST_ALPHA, gl.ONE);
			break;
		case 'always':
			gl.enable(gl.BLEND);
			gl.blendEquation(gl.FUNC_ADD);
			gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
			break;
		}
		shader.select();
		image.bind();
		shader.setUniform('sampler', 0);
		for (let y = 0; y < 2; y++) {
			for (let x = 0; x < 2; x++) {
				const i = y * 2 + x;
				const xs = x * 2 - 1;
				const ys = y * 2 - 1;
				shader.setUniform('tex_offset', [x / 2, y / 2]);
				shader.setUniform('vertex_offset', [x, y]);
				const m = Matrix.createIdentity(4);
				/* Rescale vertex coordinates to -1/2..+1/2 */
				m.translateBy(-1, -1);
				m.scaleBy(0.5, 0.5);
				/* Scale about centre of image */
				m.scaleBy(opts.scale, opts.scale);
				/* Rotate quadrant about image centre */
				m.rotateBy2D(opts.rotation[0] - opts.rotation[1]);
				/* Split */
				m.translateBy(xs * opts.split[i][0], ys * opts.split[i][1]);
				/* Rotate split image about centre */
				m.rotateBy2D(opts.rotation[1]);
				m.hyperBy(...opts.hyper);
				//m.hyperBy(2*Math.cos(+new Date() / 300 % 6.3), 0);
				/* Translate, aspect/flip correction */
				m.translateBy(...opts.position);
				m.scaleBy(aspect, -1);
				/* Render */
				shader.setUniform('transform', m._m);
				this._texcoords.bind(shader);
				this._vertices.draw(shader, gl.TRIANGLE_STRIP);
			}
		}
	}

}
